import { CheckboxTypes, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { PrivatePensionContractedTabProps } from '../../constants';

import { SecondCopyActions } from './components/SecondCopyActions';
import { SecondCopyEmailFields } from './components/SecondCopyEmailFields';
import { getDefaultValues } from './components/SecondCopyEmailFields/constants';
import { SecondCopyHeader } from './components/SecondCopyHeader';
import { SecondCopyList } from './components/SecondCopyList';

export const SecondCopy: React.FC<PrivatePensionContractedTabProps> = ({ setSelectedTab }) => {
  const [buttonDisabled, setButtonDisabled] = React.useState(true);
  const [emails, setEmails] = React.useState(getDefaultValues());
  const [linesChecked, setLinesChecked] = React.useState<CheckboxTypes.Option['value'][]>([]);

  const handleConfirm = () => {
    console.log('Confirm', { emails, linesChecked });
  };

  return (
    <VStack space={Spacing['stack.xxxs']} flex={1}>
      <SecondCopyHeader setSelectedTab={setSelectedTab} />
      <SecondCopyEmailFields
        setButtonDisabled={setButtonDisabled}
        emails={emails}
        setEmails={setEmails}
      />
      <SecondCopyList linesChecked={linesChecked} setLinesChecked={setLinesChecked} />
      <SecondCopyActions handlePressButton={handleConfirm} buttonDisabled={buttonDisabled} />
    </VStack>
  );
};
